import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconTrophy$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconTrophy extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b001bcb97ff9298585f80ed1ea854b3d01017f1a', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '28b49a5e9c93997cc170a20d411c4fdd21475d22', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '397e8e3eecaf399643a914cdf0e32ffc206e1624', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14 12.4c3.35-1.16 5-3.69 5-5.61a4.25 4.25 0 0 0-1.27-3.29 1.94 1.94 0 0 0-1.32-.5H5.62a2 2 0 0 0-1.35.52A4.23 4.23 0 0 0 3 6.75c0 2 1.22 4.43 5 5.64a12.1 12.1 0 0 0 2.25 2.89v2.22H6.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5h-3.75v-2.2A11.8 11.8 0 0 0 14 12.4m2.6-7.9a2.7 2.7 0 0 1 .9 2.29c0 1.11-.9 2.62-2.74 3.64.16-.699.24-1.413.24-2.13a13.2 13.2 0 0 0-.53-3.8zM4.5 6.75a2.71 2.71 0 0 1 .92-2.25h2.11A12.8 12.8 0 0 0 7 8.25a9.3 9.3 0 0 0 .27 2.24C4.76 9.28 4.5 7.44 4.5 6.75", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-trophy", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-trophy"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-trophy":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconTrophy$1);
            }
            break;
    } });
}

const CosmosIconTrophy = CosmosIconTrophy$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconTrophy, defineCustomElement };
